exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!bootstrap/dist/css/bootstrap.css"), "");

// module
exports.push([module.id, "[data-v-83b73948].popover{background-color:hsla(0,0%,100%,.95)!important}[data-v-83b73948] .popover-header{line-height:1.5}[data-v-83b73948] .popover-body{display:flex;gap:5px;padding:3px 6px!important}", ""]);

// exports
